import angular from 'angular';
import gettext from 'angular-gettext';
import MediaResource from '../MediaResource';
import config from '../../ConfigModule/ConfigModule';
import uibModal from 'angular-ui-bootstrap/src/modal'
import MediaUsage from '../MediaUsage';
import mediaPickerModal from '../MediaPickerModal/MediaPickerModal';

export default angular.module('cms.media.picker', [config, MediaResource, uibModal, mediaPickerModal, gettext])
    .component('mediaPicker', {
        template: require('./media-picker.html'),
        require:{
            ngModel: '^'
        },
        bindings: {
            media: '<',
            onRemoved: '&',
            width: '<',
            height: '<'
        },
        controller: function ($scope, $uibModal, MediaPickerModal, gettextCatalog) {
            /** @ngInject */

            this.$onInit = () => {

                if(this.ngModel.$modelValue) {
                    this.selectedMedia = this.ngModel.$modelValue;
                    this.resultPreview = new MediaUsage(media, this.width, this.height);
                }
            };

            /**
             * Used from in the modal to remember current selection
             *
             * @private
             * @param {MediaResource} media
             */
            this.onMediaSelected = media => {
                this.selectedMedia = media;
            };

            /**
             * Clear the model, media and preview
             *
             * @private
             */
            this.clearSelection = () => {
                this.selectedMedia = null;
                this.ngModel.$setViewValue(null);
                this.resultPreview = null;
            };

            /**
             * Open the modal
             *
             * @private
             */
            this.openMediaPickerModal = ()=> {
                MediaPickerModal.open().result.then(media => {
                    this.resultPreview = new MediaUsage(media, this.width, this.height);
                    this.ngModel.$setViewValue(new MediaUsage(media, this.width, this.height));

                });
            }
        }
    })
    .name;


// WEBPACK FOOTER //
// ./src/cmsCore/MediaModules/MediaPicker/MediaPicker.js